import React from "react";
import About from "./components/About";
import Education from "./components/Education";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import WorkExperience from "./components/WorkExperience";

export default function App() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Projects />
      <Skills />
      <WorkExperience />
      <Education />
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js